import clsx from 'clsx';
import { useEffect, useState } from 'react';
import styles from './styles.module.scss';

export interface ActionInputProps {
  id?: string;
  'data-testid'?: string;
  className?: string;
  placeholder?: string;
  defaultValue: string;
  action: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disable?: boolean;
  type?: string;
  autoComplete?: string;
}

export function ActionInput({
  id,
  'data-testid': dataTestId,
  className,
  placeholder,
  defaultValue,
  action,
  type,
  autoComplete,
}: ActionInputProps) {
  const [value, setValue] = useState('');

  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    action(e);
  };

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  return (
    <input
      id={id}
      data-testid={dataTestId}
      type={type}
      className={clsx(styles.root, className)}
      value={value}
      placeholder={placeholder}
      onChange={e => handleInput(e)}
      autoComplete={autoComplete}
    />
  );
}
